export function has<T extends object, K extends PropertyKey>(
  obj: T,
  property: RequireLiteral<K>
): obj is { [P in K]: { [Q in P]: unknown } }[K] & T;
export function has(obj: any, property: PropertyKey): boolean;
export function has(obj: any, property: PropertyKey): boolean {
  const result = Object.hasOwn(obj as object, property);
  return result;
}

type RequireLiteral<K extends PropertyKey> = string extends K
  ? never
  : number extends K
    ? never
    : symbol extends K
      ? never
      : K;
